export default __webpack_public_path__ + "static/media/video7.f602e55e.mp4";